exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#brand-wrapper[data-v-48785d6f]{line-height:35px;vertical-align:middle}#brand-logo[data-v-48785d6f]{height:21.5px;vertical-align:middle}#brand-title[data-v-48785d6f]{vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48785d6f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header.vue
// module id = 513
// module chunks = 0